const { REACT_APP_STRAPI_DEV } = process.env;

export const config = {
  strapiURL: REACT_APP_STRAPI_DEV ?? 'https://cms.yakistan.thesamdickey.com'
};
